/**
 * LinkButtonWithLicense Component
 */

import {
  generateLicenseUsageFromComponents,
  isLicenseValid,
  licenseUsagesToSearchParams,
} from '../../../../redux/helpers/license';
import { createHref, getRouteLocation } from '../../../../utils/router';
import './styles.scss';

import { withRouter, WithRouter } from 'found';
import * as React from 'react';

import { generateQueryStringFromState, getQueryStringStateForRoute } from '../../../../contexts/queryString/helpers';
import LinkButton, { LinkButtonProps } from '../LinkButton';

interface IOwnStateProps {
  licenseParams: ITermsState | undefined;
}

interface IOwnProps extends LinkButtonProps {
  lineItemLicense?: GQL.IStandardLicense;
  to: string;
}

type LinkButtonWithLicenseProps = IOwnProps & IOwnStateProps & WithRouter;

class LinkButtonWithLicense extends React.PureComponent<LinkButtonWithLicenseProps, any> {
  render() {
    const {
      licenseParams,
      lineItemLicense,
      match,
      to,
      ...linkButtonProps
    } = this.props;

    const queryStringState = getQueryStringStateForRoute(match);
    let license = queryStringState.license_params;

    if (lineItemLicense) {
      const usages = lineItemLicense.usages!.map(({ components }) =>
        generateLicenseUsageFromComponents(components!),
      );
      license = licenseUsagesToSearchParams(usages);
    } else if (!!licenseParams && isLicenseValid(licenseParams.usages)) {
      license = licenseUsagesToSearchParams(licenseParams.usages);
    }

    const query = generateQueryStringFromState({
      ...queryStringState,
      license_params: license,
    });

    const link = getRouteLocation(to, query);

    return <LinkButton to={createHref(link)} {...linkButtonProps} />;
  }
}

export default withRouter<IOwnProps>(LinkButtonWithLicense);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/buttons/LinkButtonWithLicense/index.tsx